module.exports = __webpack_public_path__ + "media/images/xpass/landing_page/achievements-28869752c63097407c52673a3f6364b1.png";